// extracted by mini-css-extract-plugin
module.exports = {"link":"ValuablesInfoCard_link__xv1gn","bold":"ValuablesInfoCard_bold__ZZEM0"};